import {
    ODataHeader,
    ODataString,
    ODataInteger
} from "pbas-vue-components";

import { translateProperty } from '../trans'
import store from '@/store'
/*
http://localhost:5000/cms/Plans(c8380bca-674d-46b1-97c7-64dea63784c6)/SidebarItems?$count=true&$skip=0&$top=20&$select=Id,Title
http://localhost:5000/cms/odata/Plans(c8380bca-674d-46b1-97c7-64dea63784c6)/SidebarItems
http://localhost:5015/odata/plans(c8380bca-674d-46b1-97c7-64dea63784c6)/SidebarItems
*/
const SidebarItemsHeaders = [
    new ODataHeader({
        title: "Id",
        type: new ODataString("Id"),
        sortable: true,
        visible: false,
        searchable: false,
        isIdentifier: true,
        allowVisibilityChange: false,
        version: 1
    }),
    new ODataHeader({
        title: "globals.title",
        type: new ODataString("Translations[]/Title", {
            getString: function(item) {
                const lang = store.getters['common/language']
                return translateProperty(item, 'Title', lang.language);
            }
        }),
        sortable: true,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
        title: "globals.priority",
        type: new ODataInteger("Order"),
        sortable: true,
        visible: true,
        allowVisibilityChange: true,
        searchable: true
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Translations[]/LanguageCode"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Translations[]/Id"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        title: "headers.sidebaritems.banner",
        type: new ODataString("Translations[]/Source/PhysicalFile/Path", {
            getString: function(item) {
                return item.Translations.map(o=>{
                    //console.log(o);
                    return o.LanguageCode+": <a href=\""+ o.Source.PhysicalFile.Path+"\" target=\"_blank\">"+ o.Source.PhysicalFile.Path+"</a>"
                }).join("\n");
            },
            getHtml: (item, type) => {
                return (
                    "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 300px'>" +
                    type.getString(item, type) +
                    "</div>"
                );
            }
        }),
        sortable: false,
        visible: true,
        allowVisibilityChange: true,
        searchable: true,
        version: 1
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Translations[]/Source/PhysicalFile/Id"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    // new ODataHeader({
    //     title: "globals.name",
    //     type: new ODataString("Translations[]/Icon/PhysicalFile/Path"),
    //     sortable: false,
    //     visible: false,
    //     allowVisibilityChange: false,
    //     searchable: false
    // }),
    // new ODataHeader({
    //     title: "globals.name",
    //     type: new ODataString("Translations[]/Icon/PhysicalFile/Id"),
    //     sortable: false,
    //     visible: false,
    //     allowVisibilityChange: false,
    //     searchable: false
    // }),
    new ODataHeader({
        title: "components.getreports.pdf",
        type: new ODataString("Translations[]/Pdf/Path", {
            getString: function(item) {
                return item.Translations.map(o=>{
                    //console.log(o);
                    if (o.Pdf===null || o.Pdf === undefined) return ""
                    return o.LanguageCode+": <a href=\""+ o.Pdf.Path+"\" target=\"_blank\">"+ o.Pdf.Path+"</a>"
                }).join("\n");
            },
            getHtml: (item, type) => {
                return (
                    "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 300px'>" +
                    type.getString(item, type) +
                    "</div>"
                );
            }
        }),
        sortable: false,
        visible: true,
        allowVisibilityChange: true,
        searchable: true,
        version: 1
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Translations[]/Pdf/Id"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    // new ODataHeader({
    //     title: "globals.name",
    //     type: new ODataString("Translations[]/PdfId"),
    //     sortable: false,
    //     visible: false,
    //     allowVisibilityChange: false,
    //     searchable: false
    // }),
    // new ODataHeader({
    //     title: "globals.name",
    //     type: new ODataString("Translations[]/Pdf/Name"),
    //     sortable: false,
    //     visible: false,
    //     allowVisibilityChange: false,
    //     searchable: false
    // }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("PlanId"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false
    }),
    new ODataHeader({
        type: new ODataString("ClassSidebarItem/Class"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
        version: 2
    }),
    new ODataHeader({
        type: new ODataString("AllowedGuest"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
        version: 1
    }),
];
export default SidebarItemsHeaders;